// eslint-disable-next-line max-classes-per-file
export class ApiInvalidParamError extends Error {
  constructor(message = 'Error', response) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiInvalidParamError);
    }

    this.name = 'ApiInvalidParamError';
    this.message = message;
    this.response = response;
    this.badParams = response.data && response.data.params ? response.data.params : undefined;
    this.responseMessage = response.message;
  }
}

export class ApiFatalError extends Error {
  constructor(message = 'Error', response) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiInvalidParamError);
    }

    this.name = 'ApiFatalError';
    this.message = message;
    this.response = response;
  }
}
